import { AlertTriangle, ArrowDown } from "lucide-react";
import type { NicheConfig } from "../../types/niche";
import { formatBRL } from "../../lib/format";

export function NicheHero({ config }: { config: NicheConfig }) {
  return (
    <section data-testid="niche-hero" className="border-b border-slate-800">
      <div className="fade-up mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-20">
        <div data-testid="niche-target-pain" className="flex max-w-2xl gap-3 rounded-md border border-amber-500/20 bg-amber-500/5 p-4 text-sm leading-relaxed text-slate-300">
          <AlertTriangle aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-amber-400" />
          {config.targetPain}
        </div>
        <h1 data-testid="niche-headline" className="mt-8 max-w-4xl text-4xl font-semibold leading-[1.1] tracking-tight text-slate-100 sm:text-5xl lg:text-6xl">
          {config.headline}
        </h1>
        <p data-testid="niche-subheadline" className="mt-6 max-w-3xl text-base leading-relaxed text-slate-300 md:text-lg">
          {config.subheadline}
        </p>
        <div className="mt-10 flex flex-col gap-6 sm:flex-row sm:items-center">
          <div data-testid="niche-price" className="max-w-md rounded-md border border-slate-800 bg-slate-900 px-5 py-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-slate-400">Taxa única de emissão</p>
            <p data-testid="niche-price-value" className="mt-1 text-3xl font-semibold text-slate-100">{formatBRL(config.price)}</p>
            <p data-testid="niche-price-note" className="mt-2 text-xs leading-relaxed text-slate-400">({config.priceNote})</p>
          </div>
          <a href="#protocolo" data-testid="niche-hero-cta" className="btn-primary">
            Iniciar minha notificação <ArrowDown aria-hidden="true" className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
